// @ts-nocheck
// TODO: tighten types after migration
import { API_ENDPOINTS } from '../config/api';
import { clearCart } from './cartUtils';

async function safeJsonParse(response) {
    const rawText = await response.text();
    const trimmed = rawText ? rawText.trim() : '';
    if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
        return null;
    }
    return JSON.parse(trimmed);
}

class PaymentService {
    constructor() {
        this.loadRazorpayScript();
    }

    loadRazorpayScript() {
        return new Promise((resolve, reject) => {
            if (window.Razorpay) {
                resolve(window.Razorpay);
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.async = true;
            script.crossOrigin = 'anonymous';
            script.onload = () => {
                if (window.Razorpay) {
                    resolve(window.Razorpay);
                } else {
                    reject(new Error('Razorpay object not available after script load'));
                }
            };
            script.onerror = (error) => {
                console.error('Razorpay script loading failed:', error);
                reject(new Error('Failed to load Razorpay script. Check network connection and CSP settings.'));
            };
            document.head.appendChild(script);
        });
    }

    loadRazorpayScriptAlternative() {
        return new Promise((resolve, reject) => {
            // Try loading from a different CDN or method
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                setTimeout(() => {
                    if (window.Razorpay) {
                        resolve(window.Razorpay);
                    } else {
                        reject(new Error('Razorpay not available after alternative loading'));
                    }
                }, 1000);
            };
            script.onerror = () => {
                reject(new Error('Alternative Razorpay loading also failed'));
            };
            document.head.appendChild(script);
        });
    }

    async createPaymentOrder(orderData) {
        try {
            const response = await fetch(`${API_ENDPOINTS.PAYMENT.CREATE_ORDER}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(orderData)
            });

            const result = await safeJsonParse(response);

            if (!result || !result.success) {
                throw new Error((result && result.message) || 'Failed to create payment order');
            }

            return result.data;
        } catch (error) {
            console.error('Error creating payment order:', error);
            throw error;
        }
    }

    async verifyPayment(paymentData) {
        try {
            const response = await fetch(`${API_ENDPOINTS.PAYMENT.VERIFY}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(paymentData)
            });

            const result = await safeJsonParse(response);

            if (!result || !result.success) {
                throw new Error((result && result.message) || 'Payment verification failed');
            }

            return result.data;
        } catch (error) {
            console.error('Error verifying payment:', error);
            throw error;
        }
    }

    async getPaymentStatus(orderId) {
        try {
            const response = await fetch(`${API_ENDPOINTS.PAYMENT.STATUS}/${orderId}`);
            const result = await safeJsonParse(response);

            if (!result || !result.success) {
                throw new Error((result && result.message) || 'Failed to get payment status');
            }

            return result.data;
        } catch (error) {
            console.error('Error getting payment status:', error);
            throw error;
        }
    }

    async initiatePayment(orderData) {
        try {
            // Create payment order
            const paymentOrder = await this.createPaymentOrder(orderData);
            
            // Load Razorpay with retry mechanism
            let Razorpay;
            try {
                Razorpay = await this.loadRazorpayScript();
            } catch (error) {
                console.error('Failed to load Razorpay script:', error);
                // Try alternative loading method
                Razorpay = await this.loadRazorpayScriptAlternative();
            }
            
                         // Configure Razorpay options
             const options = {
                 key: paymentOrder.key || process.env.REACT_APP_RAZORPAY_KEY_ID,
                 amount: paymentOrder.amount,
                 currency: paymentOrder.currency,
                name: 'Harivishnu.in Store',
                description: `Order ${paymentOrder.orderId}`,
                order_id: paymentOrder.razorpayOrderId,
                handler: async (response) => {
                    try {
                        // Verify payment
                        const verificationData = {
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                            orderId: paymentOrder.orderId
                        };

                        const verificationResult = await this.verifyPayment(verificationData);
                        
                        // Clear cart after successful payment
                        clearCart();
                        
                        // Redirect to success page
                        window.location.href = `/order-success?orderId=${paymentOrder.orderId}&paymentId=${response.razorpay_payment_id}`;
                        
                        return verificationResult;
                    } catch (error) {
                        console.error('Payment verification failed:', error);
                        alert('Payment verification failed. Please contact support.');
                        throw error;
                    }
                },
                prefill: {
                    name: (orderData.shippingAddress && orderData.shippingAddress.name) || undefined,
                    email: orderData.email || undefined,
                    contact: orderData.contactNumber ? orderData.contactNumber.replace(/\s+/g, '') : undefined
                },
                notes: {
                    orderId: paymentOrder.orderId
                },
                theme: {
                    color: '#3399cc'
                },
                modal: {
                    ondismiss: () => {
                        // Payment modal dismissed
                    }
                }
            };

            console.log('Initializing Razorpay with options:', { ...options, key: 'HIDDEN' });

            // Open Razorpay modal
            const rzp = new Razorpay(options);
            rzp.open();

            return { paymentOrder, rzp };
        } catch (error) {
            console.error('Error initiating payment:', error);
            throw error;
        }
    }
}

const paymentService = new PaymentService();
export default paymentService;

